// /src/bootstrapAuth.js

import { authHttp } from "../utils/authHttp";

function isSharedDomainHost() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "pallas-invictus.com" || host.endsWith(".pallas-invictus.com");
}

async function clearLegacyAuthCookies() {
  if (!isSharedDomainHost()) return;
  try {
    await authHttp.post("/api/auth/clear-legacy-cookies", {});
  } catch (err) {
    console.warn("[bootstrapAuth] clear-legacy-cookies failed:", err?.message || err);
  }
}

async function requestCheckToken() {
  return authHttp.post("/api/user/check-token", {});
}

async function runCheckTokenWithLegacyCleanup() {
  try {
    return await requestCheckToken();
  } catch (firstErr) {
    const status = firstErr?.response?.status;
    if (status !== 401 && status !== 419) {
      throw firstErr;
    }

    await clearLegacyAuthCookies();
    return requestCheckToken();
  }
}

export async function bootstrapAuth() {
  try {
    const checkRes = await runCheckTokenWithLegacyCleanup();
    const checkData = checkRes.data || {};

    if (!["ok", "refreshed"].includes(checkData.status)) {
      console.warn(`[bootstrapAuth] Token status: ${checkData.status}`);
      return { user: null, permissions: null };
    }

    const userRes = await authHttp.get("/api/user/info");
    const userData = userRes.data || null;

    if (!userData?.isLoggedIn) {
      console.warn("[bootstrapAuth] User not logged in → skipping permissions");
      return { user: null, permissions: null };
    }

    const permRes = await authHttp.post("/api/security/user-permissions", {});
    const raw = Array.isArray(permRes.data?.permissions)
      ? permRes.data.permissions
      : Array.isArray(permRes.data)
      ? permRes.data
      : [];

    const cleanedPermissions = raw
      .map((p) => ({
        resourceKey: p?.resourceKey ?? p?.resource ?? null,
        action: p?.action ?? p?.permission ?? null,
      }))
      .filter((p) => p.resourceKey && p.action);

    const permissionsData = {
      permissions: cleanedPermissions,
      isSuperAdmin: Boolean(permRes.data?.isSuperAdmin),
      isGuest: Boolean(permRes.data?.isGuest),
    };

    return { user: userData, permissions: permissionsData };
  } catch (err) {
    const status = err?.response?.status || "unknown";
    console.warn(`[bootstrapAuth] Failed during bootstrap (status: ${status})`);
    return { user: null, permissions: null };
  }
}
